import styled from "styled-components"
import Container from "@/components/common/Container"
import GridCards from "@/components/common/Cards/Grid"
import React, { useMemo } from "react"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const StyledWrapper = styled.div``

export default function TilesImageHeaderDescription({ data, paddings, headerDescription }) {
	const cards = data?.tiles || []
	const id = data?.id || ""

	const formattedCards = useMemo(() => {
		return cards.map((card) => {
			return {
				card: {
					...card,
				},
			}
		})
	}, [data])

	return (
		<StyledWrapper id={id} className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<Container>
				<GridCards data={formattedCards} tag="div" smallCover />
			</Container>
		</StyledWrapper>
	)
}
